import { useState, useCallback } from 'react'

import type { GroupMember } from '@percent/admin-dashboard/api/actions/groups/groups.types'

export interface UseChangeRoleModalProps {
  onSuccess?: () => void
}

export function useChangeRoleModal({ onSuccess }: UseChangeRoleModalProps = {}) {
  const [member, setMember] = useState<GroupMember | null>(null)

  const openModal = useCallback((data: GroupMember) => {
    setMember(data)
  }, [])

  const closeModal = useCallback(() => {
    setMember(null)
  }, [])

  return {
    isOpen: !!member,
    member,
    openModal,
    closeModal,
    onSuccess
  }
}
